import ToolsView from "@features/tools/view/tools-view";

const Tools = () => {
  return <ToolsView />;
};

export default Tools;
